import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    frame: String,
    duration: { type: Number, default: 10 }
  }

  static targets = ["countdown"]

  connect() {
    // this.startCountdown()
    this.setupFrameListener()
  }

  disconnect() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }
    this.removeFrameListener()
  }

  setupFrameListener() {
    if (this.hasFrameValue) {
      const frame = document.getElementById(this.frameValue)
      if (frame) {
        this.frameLoadHandler = () => {
          this.startCountdown()
        }
        frame.addEventListener('turbo:frame-load', this.frameLoadHandler)
      }
    }
  }

  removeFrameListener() {
    if (this.hasFrameValue && this.frameLoadHandler) {
      const frame = document.getElementById(this.frameValue)
      if (frame) {
        frame.removeEventListener('turbo:frame-load', this.frameLoadHandler)
      }
    }
  }

  startCountdown() {
    // Clear any existing interval
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval)
    }

    let timeLeft = this.durationValue
    
    // Update the countdown display immediately
    this.updateCountdownDisplay(timeLeft)
    
    this.countdownInterval = setInterval(() => {
      timeLeft--
      
      if (timeLeft >= 0) {
        this.updateCountdownDisplay(timeLeft)
      }
      
      if (timeLeft <= 0) {
        this.reloadFrame()
        clearInterval(this.countdownInterval)
      }
    }, 1000)
  }

  updateCountdownDisplay(timeLeft) {
    if (this.hasCountdownTarget) {
      const minutes = Math.floor(timeLeft / 60)
      const seconds = timeLeft % 60
      const displayTime = `${minutes}:${seconds.toString().padStart(2, '0')}`
      this.countdownTarget.textContent = displayTime
    }
  }

  reloadFrame() {
    if (this.hasFrameValue) {
      const frame = document.getElementById(this.frameValue)
      if (frame) {
        frame.src = frame.src
      }
    }
  }
} 